import { EMPTY_FIELD_PLACEHOLDER } from '../Statics/Constants';

export function formatDate(d?: string) {
  if (!d) return EMPTY_FIELD_PLACEHOLDER;
  try {
    return new Date(d).toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return d;
  }
}
